import setSelectedFiles from '../actions/setSelectedFiles'
import filePropsSetter from '../factories/filePropsSetter'
import { debounce, set, when, toggle, merge, unset } from 'cerebral/operators'
import { state, props, string } from 'cerebral/tags'
import loadDetails from '../actions/loadDetails'
import setTagsForm from './setTagsForm'
import handleShiftKey from '../actions/handleShiftKey'

export default [
  debounce(50),
  {
    continue: [
      when(
        state`media.keyboard.keys.17`,
        state`media.keyboard.keys.91`,
        (ctrl, cmd) => ctrl || cmd
      ),
      {
        true: [
          toggle(state`${props`path`}.selected`),
          setSelectedFiles,
          when(state`${props`path`}.selected`),
          {
            true: [set(state`media.currentFile`, props`path`)],
            false: [
              when(state`media.selectedFiles`, value => value.length === 0),
              {
                true: [unset(state`media.currentFile`)],
                false: [
                  set(
                    state`media.currentFile`,
                    string`media.files.${state`media.selectedFiles.0`}`
                  )
                ]
              }
            ]
          }
        ],
        false: [
          // shift
          when(state`media.keyboard.keys.16`),
          {
            true: [
              when(state`media.currentFile`),
              {
                true: [
                  when(
                    state`${props`path`}`,
                    state`media.currentFile`,
                    (clickedFile, currentFile) => clickedFile === currentFile
                  ),
                  {
                    true: [],
                    false: [handleShiftKey, setSelectedFiles]
                  }
                ],
                false: [
                  set(state`${props`path`}.selected`, true),
                  set(state`media.currentFile`, props`path`)
                ]
              }
            ],
            false: [
              when(state`${props`path`}.selected`),
              {
                true: [set(state`media.currentFile`, props`path`)],
                false: [
                  filePropsSetter('media.files', {
                    prop: 'selected',
                    value: false
                  }),
                  set(state`${props`path`}.selected`, true),
                  set(state`media.currentFile`, props`path`)
                ]
              },
              setSelectedFiles
            ]
          }
        ]
      },
      when(state`media.selectedFiles`, value => value.length < 2),
      {
        true: [set(state`media.tags.showShared`, false)],
        false: []
      },
      when(state`media.currentFile`),
      {
        true: [
          when(state`${props`path`}.groups`), // if we have groups the media detail is loaded
          {
            true: [],
            false: [
              set(props`id`, state`${props`path`}.id`),
              set(state`media.tags.isLoading`, true),
              loadDetails,
              {
                loaded: [
                  merge(state`${props`path`}`, props`payload`),
                  set(state`media.tags.isLoading`, false)
                ],
                error: []
              }
            ]
          },
          ...setTagsForm
        ],
        false: []
      }
    ],
    discard: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/mediaClicked.js